/**
 * Soft refresh signal for script list pages.
 *
 * List pages keep scripts in local mount-only state. Chat create / navigate
 * (and other in-app mutations) can leave that state stale while the user stays
 * on the list. Emit this event after a script is created or opened so open
 * list views refetch without a hard reload.
 */

export const SCRIPT_LIST_REFRESH_EVENT = "gail:script-list-refresh";

export type ScriptListRefreshDetail = {
  scriptId?: string;
  direction?: "inbound" | "outbound";
};

export function notifyScriptListRefresh(detail?: ScriptListRefreshDetail): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<ScriptListRefreshDetail>(SCRIPT_LIST_REFRESH_EVENT, {
      detail: detail ?? {},
    })
  );
}
